import * as Highcharts from 'highcharts/highcharts';
import { AssistantChatChart } from '../../interfaces/assistant-chat.interface';

const CHART_HEIGHT_PX = 200;
const COMPACT = new Intl.NumberFormat(undefined, { notation: 'compact', maximumFractionDigits: 1 });
const PLAIN = new Intl.NumberFormat(undefined, { maximumSignificantDigits: 3 });

export function compactNumber(value: number): string {
  return Math.abs(value) >= 1000 ? COMPACT.format(value) : PLAIN.format(value);
}

export function chartOptions(block: AssistantChatChart, colors: string[]): Highcharts.Options {
  const pie = block.kind === 'pie';
  const series: Highcharts.SeriesOptionsType[] = pie
    ? [{
        type: 'pie',
        name: block.series[0]?.name,
        data: block.categories.map((name, index) => ({ name, y: block.series[0]?.values[index] })),
      }]
    : block.series.map(line => ({
        type: block.kind === 'bar' ? 'column' : 'line',
        name: line.name,
        data: line.values,
      }));

  return {
    chart: { height: CHART_HEIGHT_PX, backgroundColor: 'transparent', style: { fontFamily: 'inherit' } },
    title: { text: null },
    credits: { enabled: false },
    colors,
    xAxis: { categories: block.categories },
    yAxis: { title: { text: null }, labels: { formatter: function () { return compactNumber(Number(this.value)); } } },
    legend: { enabled: pie || block.series.length > 1 },
    series,
  };
}
